import { useEffect, useState } from "react";
import { api } from "../lib/api";
import Seo from "../components/Seo";
import { SectionHead, ChallengeCard, EmptyState, Loader } from "../components/Blocks";

export default function Challenges() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/public/challenges").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  if (items === null) return <Loader />;

  return (
    <div data-testid="challenges-page" className="max-w-[1600px] mx-auto px-6 lg:px-12 py-16 lg:py-24">
      <Seo
        title="Challenges"
        description="Les challenges VytaliBoots : meilleure photo, meilleure énergie, meilleur moment partenaire et plus."
        path="/challenges"
        kind="challenge"
      />
      <SectionHead as="h1" label="Communauté" title="Challenges">
        Participation, créativité et interaction authentique. Le nombre d'abonnés n'est pas le
        critère principal.
      </SectionHead>
      {items.length === 0 ? (
        <EmptyState message="Aucun challenge publié." testid="challenges-empty" />
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-10" data-testid="challenges-grid">
          {items.map((c, i) => (
            <ChallengeCard key={c.id} challenge={c} testid={`challenge-card-${i}`} />
          ))}
        </div>
      )}
    </div>
  );
}
